import { render, staticRenderFns } from "./SettledList.vue?vue&type=template&id=355b049e&scoped=true&"
import script from "./SettledList.vue?vue&type=script&lang=js&"
export * from "./SettledList.vue?vue&type=script&lang=js&"
import style0 from "./SettledList.vue?vue&type=style&index=0&id=355b049e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b049e",
  null
  
)

export default component.exports